import * as broadcastService from '@/services/broadcast'

const state = () => ({
  list: [],
  current: 'id',
})

// getters
const getters = {
  playlists: (state: any) => state.list,
}

// actions
const actions = {
  async fetchUserPlaylist({ commit, state }: any, data: any) {
    const playlists = await broadcastService.getUserPlaylist(data)
    commit('setPlaylists', playlists.data)
  },
}

// mutations
const mutations = {
  setPlaylists(state: any, playlists: any) {
    state.list = playlists
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
